import { useSelector } from 'react-redux'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
  useHistory,
} from 'react-router-dom'
import { useEffect } from 'react'
import NavigationBar from 'components/navigation-bar'
import AdminAccountPage from 'pages/admin-account-page'
import HomePage from 'pages/home-page'
import InsightsPage from 'pages/insights-page'
import LoginConfirmationPage from 'pages/login-confirmation-page'
import LoginPage from 'pages/login-page'
import ProductDetailPage from 'pages/product-detail-page'
import ProductsPage from 'pages/products-page'
import OrganizationsPage from 'pages/organizations-page'
import OrganizationDetailPage from 'pages/organization-detail-page'
import EntityRedirect from 'components/entity-redirect'
import OrganizationMessagesPage from 'pages/organization-messages-page'
import OrganizationBulkUploadsPage from 'pages/organization-bulk-uploads-page'
import OrganizationsMissingInfoPage from 'pages/organizations-missing-info-page'
import TeamDetailPage from 'pages/team-detail-page'
import UserDetailPageOld from 'pages/user-detail-page-old'
import UserDetailPage from 'pages/user-detail-page'
import UsersPage from 'pages/users-page'
import UserCreatePage from 'pages/user-create-page'
import UserMessagesPage from 'pages/user-messages-page'
import UserPermissionEventsPage from 'pages/user-permission-events-page'
import UserPanopticonProfilePage from 'pages/user-panopticon-profile-page'
import ProductEditPage from 'pages/product-edit-page'
import ZakekeOrdersPage from 'pages/zakeke-orders-page'
import PrintFilesPage from 'pages/print-files-page'
import ProductCreatePage from 'pages/product-create-page'
import ZakekeOrderEditPage from 'pages/zakeke-order-edit-page'
import ContactPageDetails from 'pages/contact-detail-page'
import OrganizationIntegrationConnectionsPage from 'pages/organization-integration-connections-page'
import PartnerIntegrationDetailPage from 'pages/partner-integration-detail-page'
import { Toaster } from 'react-hot-toast'
import OrganizationCreatePage from 'pages/organization-create-page'
import WeeklyAnalyticsEmailPage from 'pages/weekly-analytics-email'
import BugReporterPage from 'pages/bug-reporter-page'
import { RootState } from 'index'
import { AudioProvider } from 'contexts/AudioContext'
import OrganizationSSOPage from 'pages/organization-sso-page'
import OrganizationBlockedNumbersPage from 'pages/organization-blocked-numbers-page'
import UserBlockedNumbersPage from 'pages/user-blocked-numbers-page'
import StripeProductsListPage from 'pages/stripe-products-list-page'
import EntitlementGroupingsPage from 'pages/entitlement-groupings-page'
import EntitlementGroupingPage from 'pages/entitlement-grouping-page'
import ZakekeProductsPage from 'pages/zakeke-products-page'
import ZakekeProductCreatePage from 'pages/zakeke-product-create-page'
import ProductJigTemplateCreatePage from 'pages/product-jig-template-create-page'
import ProductJigTemplatesPage from 'pages/product-jig-templates-page'
import ProductJigTemplateEditPage from 'pages/product-jig-template-edit-page'
import ZakekeProductEditPage from 'pages/zakeke-product-edit-page'
import CreateEntitlementGroupingPage from 'pages/create-entitlement-grouping-page'
import UserScriptsPage from 'pages/user-scripts-page'
import ProductQrCodeGenerationPage from 'pages/product-qr-code-generation-page'
import NonSubscriptionLinkBuilderPage from 'pages/non-subscription-link-builder-page'
import SubscriptionLinkBuilderPage from 'pages/subscription-link-builder-page'
import SubscriptionPurchaseOrderBuilderPage from 'pages/subscription-purchase-order-builder-page'
import StripeUpdatePage from 'pages/stripe-update-page'

import SandboxesPage from 'pages/sandboxes-page'
import CliUsersPage from 'pages/cli-users-page'
import InventoryPage from 'pages/inventory-page'
import InventoryTerminalDetailPage from 'pages/inventory-terminal-detail-page'
import InventoryAnsibleDetailPage from 'pages/inventory-ansible-detail-page'
import InventoryMacMiniDetailPage from 'pages/inventory-mac-mini-detail-page'
import InventoryMacMiniUsersPage from 'pages/inventory-mac-mini-users-page'

const AuthenticatedApp = () => {
  return (
    <Switch>
      <Route path="/home">
        <HomePage />
      </Route>
      <Route path="/products" exact>
        <ProductsPage />
      </Route>
      <Route path="/stripe-products-list">
        <StripeProductsListPage />
      </Route>
      <Route path="/create-product-jig-template">
        <ProductJigTemplateCreatePage />
      </Route>
      <Route path="/product-jig-templates/:productJigTemplateId/edit">
        <ProductJigTemplateEditPage />
      </Route>
      <Route path="/product-jig-templates">
        <ProductJigTemplatesPage />
      </Route>
      <Route path="/products/:productId" exact>
        <ProductDetailPage />
      </Route>
      <Route path="/products/:productId/qr-code-generation" exact>
        <ProductQrCodeGenerationPage />
      </Route>
      <Route path="/create-linq-product" exact>
        <ProductCreatePage />
      </Route>
      <Route path="/products/:productId/edit" exact>
        <ProductEditPage />
      </Route>
      <Route path="/zakeke_orders/:orderId/edit">
        <ZakekeOrderEditPage />
      </Route>
      <Route path="/zakeke_orders">
        <ZakekeOrdersPage />
      </Route>
      <Route path="/zakeke_products/:zakekeProductId/edit" exact>
        <ZakekeProductEditPage />
      </Route>
      <Route path="/zakeke_products">
        <ZakekeProductsPage />
      </Route>
      <Route path="/create-zakeke-product">
        <ZakekeProductCreatePage />
      </Route>
      <Route path="/print_files">
        <PrintFilesPage />
      </Route>
      <Route path="/users" exact>
        <UsersPage />
      </Route>
      <Route path="/users/new" exact>
        <UserCreatePage />
      </Route>
      <Route path="/sandboxes">
        <SandboxesPage />
      </Route>
      <Route path="/cli-users">
        <CliUsersPage />
      </Route>
      <Route path="/user/:uuid" exact>
        <UserDetailPage />
      </Route>
      <Route path="/user-old/:uuid" exact>
        <UserDetailPageOld />
      </Route>
      <Route path="/user/:uuid/chat_messages" exact>
        <UserMessagesPage />
      </Route>
      <Route path="/user/:uuid/permission-events" exact>
        <UserPermissionEventsPage />
      </Route>
      <Route path="/user/:uuid/panopticon-profile" exact>
        <UserPanopticonProfilePage />
      </Route>
      <Route path="/user/:uuid/blocked_numbers" exact>
        <UserBlockedNumbersPage />
      </Route>
      <Route path="/user/:uuid/scripts" exact>
        <UserScriptsPage />
      </Route>
      <Route path="/insights">
        <InsightsPage />
      </Route>
      <Route path="/organizations" exact>
        <OrganizationsPage />
      </Route>
      <Route path="/organizations-missing-info" exact>
        <OrganizationsMissingInfoPage />
      </Route>
      <Route path="/organizations/new" exact>
        <OrganizationCreatePage />
      </Route>
      <Route path="/organizations/:id" exact>
        <OrganizationDetailPage />
      </Route>
      <Route path="/organizations/:id/chat_messages" exact>
        <OrganizationMessagesPage />
      </Route>
      <Route path="/organizations/:id/bulk-uploads" exact>
        <OrganizationBulkUploadsPage />
      </Route>
      <Route path="/organizations/:id/blocked_numbers" exact>
        <OrganizationBlockedNumbersPage />
      </Route>
      <Route path="/organizations/:id/integrations" exact>
        <OrganizationIntegrationConnectionsPage />
      </Route>
      <Route path="/organizations/:orgId/partner-integrations/:id" exact>
        <PartnerIntegrationDetailPage />
      </Route>
      <Route path="/organizations/:id/sso" exact>
        <OrganizationSSOPage />
      </Route>
      <Route path="/organizations/:id/stripe-update" exact>
        <StripeUpdatePage />
      </Route>
      <Route path="/organizations/:orgId/teams/:teamId" exact>
        <TeamDetailPage />
      </Route>
      <Route path="/subscription-purchase-link/:dealid?">
        <SubscriptionLinkBuilderPage />
      </Route>
      <Route path="/subscription-purchase-order/:dealid?">
        <SubscriptionPurchaseOrderBuilderPage />
      </Route>
      <Route path="/non-subscription-purchase-link">
        <NonSubscriptionLinkBuilderPage />
      </Route>
      <Route path="/contacts/:contactId">
        <ContactPageDetails />
      </Route>
      <Route path="/account">
        <AdminAccountPage />
      </Route>
      <Route path="/emails/weekly-analytics-email">
        <WeeklyAnalyticsEmailPage />
      </Route>
      <Route path="/bug-reporter">
        <BugReporterPage />
      </Route>
      <Route path="/entitlement-groupings" exact>
        <EntitlementGroupingsPage />
      </Route>
      <Route path="/create-entitlement-grouping" exact>
        <CreateEntitlementGroupingPage />
      </Route>
      <Route path="/entitlement-groupings/:entitlementGroupingId" exact>
        <EntitlementGroupingPage />
      </Route>
      <Route path="/inventory/:entityName" exact>
        <EntityRedirect />
      </Route>
      <Route path="/inventory" exact>
        <InventoryPage />
      </Route>
      <Route path="/inventory/terminals/:terminalId" exact>
        <InventoryTerminalDetailPage />
      </Route>
      <Route path="/inventory/terminals/:terminalId/ansibles/:ansibleId" exact>
        <InventoryAnsibleDetailPage />
      </Route>
      <Route
        path="/inventory/terminals/:terminalId/ansibles/:ansibleId/mac-mini/:macMiniId/users/:userId"
        exact
      >
        <InventoryMacMiniUsersPage />
      </Route>
      <Route
        path="/inventory/terminals/:terminalId/ansibles/:ansibleId/mac-mini/:macMiniId/users"
        exact
      >
        <InventoryMacMiniUsersPage />
      </Route>
      <Route path="/inventory/terminals/:terminalId/mac-minis/:macMiniId" exact>
        <InventoryMacMiniDetailPage />
      </Route>
      <Route
        path="/inventory/terminals/:terminalId/ansibles/:ansibleId/mac-mini/:macMiniId"
        exact
      >
        <InventoryMacMiniDetailPage />
      </Route>

      <Route path="/">
        <HomePage />
      </Route>
    </Switch>
  )
}

const LoginRedirect = () => {
  const location = useLocation()

  useEffect(() => {
    // Store the original URL before redirecting to login
    if (location.pathname !== '/' && location.pathname !== '/login') {
      const redirectUrl = location.pathname + location.search
      sessionStorage.setItem('redirectAfterLogin', redirectUrl)
    }
  }, [])

  return <Redirect to="/login" />
}

const UnauthenticatedApp = () => {
  return (
    <Switch>
      <Route path="/login">
        <LoginPage />
      </Route>
      <Route path="/confirmation/:authConfirmationUUID">
        <LoginConfirmationPage />
      </Route>
      <Route>
        <LoginRedirect />
      </Route>
    </Switch>
  )
}

const AppContent = () => {
  const currentUser = useSelector((state: RootState) => state.user.currentUser)
  const history = useHistory()

  useEffect(() => {
    // Handle redirect after login
    if (currentUser) {
      const redirectUrl = sessionStorage.getItem('redirectAfterLogin')
      if (redirectUrl) {
        sessionStorage.removeItem('redirectAfterLogin')
        history.push(redirectUrl)
      }
    }
  }, [currentUser, history])

  return (
    <AudioProvider>
      <NavigationBar />
      {currentUser ? <AuthenticatedApp /> : <UnauthenticatedApp />}
      <Toaster />
    </AudioProvider>
  )
}

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App
